export const enableLowOdds = (trueOdds, enableLowOdds) => {
    const minEnableLowOdds = 1.01;
    return !enableLowOdds && trueOdds < minEnableLowOdds;
};
//# sourceMappingURL=enableLowOdds.js.map